import {trpc} from '@features/utils/trpc';

export const useLikeFeedback = (structureId: string | undefined) => {
  const trpcUtils = trpc.useUtils();

  const {data: likeFeedback, isLoading} = trpc.likes.getLikeFeedback.useQuery(
    {structureId: structureId ?? ''},
    {enabled: structureId !== undefined},
  );

  const addLikeFeedback = trpc.likes.addLikeFeedback.useMutation({
    onMutate: async (variables) => {
      if (!structureId) return;
      await trpcUtils.likes.getLikeFeedback.cancel({structureId});
      const previousData = trpcUtils.likes.getLikeFeedback.getData({
        structureId,
      });
      trpcUtils.likes.getLikeFeedback.setData(
        {structureId},
        {
          structureId: variables.structureId,
          like: variables.like,
          createdAt: previousData?.createdAt ?? new Date(),
          updatedAt: new Date(),
        },
      );
      return {previousData};
    },
    onError: (_err, _variables, context) => {
      if (context?.previousData && structureId) {
        trpcUtils.likes.getLikeFeedback.setData(
          {structureId},
          context.previousData,
        );
      }
    },
  });

  const submitFeedback = (like: boolean) => {
    if (!structureId) return;
    addLikeFeedback.mutate({
      structureId,
      like,
    });
  };

  return {
    isLoading,
    submitFeedback,
    isLiked: likeFeedback?.like === true,
    isDisliked: likeFeedback?.like === false,
  };
};
